export const Languages = Object.freeze({
  ENGLISH: "english",
  SPANISH: "spanish",
  FRENCH: "french",
  GERMAN: "german",
  ITALIAN: "italian",
});

export const LanguageLabels = {
  [Languages.ENGLISH]: "English",
  [Languages.SPANISH]: "Español",
  [Languages.FRENCH]: "Français",
  [Languages.GERMAN]: "Deutsch",
  [Languages.ITALIAN]: "Italiano",
};

export const LanguageOptions = Object.entries(LanguageLabels);
